import {TruvuMenu} from '../../../components/TruvuMenu';
import {IconButton, Stack, Typography} from '@mui/material';
import React from 'react';
import {TruvuTextField} from '../../../components/textField';
import graphql from 'babel-plugin-relay/macro';
import {useFragment} from 'relay-hooks';
import {TruvuButton} from '../../../components/button/TruvuButton';
import {ArrowForward, Close, Phone} from '@mui/icons-material';
import {TourAgentInfo_tour$key} from '../../../__generated__/TourAgentInfo_tour.graphql';
import Avatar from '@mui/material/Avatar';

const fragment = graphql`
  fragment TourAgentInfo_tour on AgentProfile {
    contactNumber
    fullname
    email
    profileImageURL
  }
`;
interface TourAgentInfoProps {
  agentRef: TourAgentInfo_tour$key;
  tourName: string;
  onClose?: () => void;
  maxWidth?: number;
  listingLink?: string;
}

export function TourAgentInfo({
  agentRef,
  tourName,
  onClose,
  maxWidth = 288,
  listingLink,
}: TourAgentInfoProps) {
  const agentInfo = useFragment(fragment, agentRef);
  const splitName = agentInfo.fullname?.split(' ') ?? [];
  const initials =
    splitName.length > 1
      ? splitName[0][0] + splitName[splitName.length - 1][0]
      : splitName.length === 1
      ? splitName[0][0]
      : 'NA';

  const onOpenWhatsapp = React.useCallback(() => {
    const phone = agentInfo.contactNumber?.replace('+', '').replace(' ', ''); // Include country code, no "+" or spaces
    const message = encodeURIComponent(
      `Hi ${agentInfo.fullname}, \nI’m interested in ${tourName}.`
    );
    const url = `https://wa.me/${phone}?text=${message}`;

    window.open(url, '_blank');
  }, [agentInfo.contactNumber, agentInfo.fullname, tourName]);

  return (
    <Stack
      spacing="15px"
      p={2}
      pt={1}
      overflow="auto"
      maxWidth={maxWidth}
      width={'100%'}
      borderRadius={1}
      bgcolor={'#fff'}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h5" component="div">
          Agent Details
        </Typography>
        {onClose && (
          <IconButton sx={{alignSelf: 'flex-start'}} onClick={onClose}>
            <Close fontSize="medium" />
          </IconButton>
        )}
      </Stack>
      <TruvuMenu
        title={agentInfo?.fullname ?? 'Anonymous Agent'}
        TitleProps={{
          className: 'dialog-title-truncate description',
        }}
        bgcolor={'#fff'}
        alwaysSpaceBetween
        action={
          agentInfo.profileImageURL ? (
            <Avatar
              src={agentInfo.profileImageURL}
              sx={{width: 60, height: 60}}
            />
          ) : (
            <Avatar sx={{width: 60, height: 60}}>{initials}</Avatar>
          )
        }
      />

      <TruvuTextField
        name="name"
        label="Name"
        value={agentInfo?.fullname ?? 'Anonymous Agent'}
        displayOnly
      />
      <TruvuTextField
        name="contactNumber"
        label="Contact Number"
        value={agentInfo?.contactNumber ?? 'N/A'}
        displayOnly
      />
      <TruvuButton
        size="small"
        variant="secondary"
        endIcon={<ArrowForward />}
        onClick={() => {
          if (listingLink) {
            window.open(listingLink, '_blank');
          }
        }}
        disabled={listingLink == null || listingLink === ''}
      >
        Listing Link
      </TruvuButton>
      <TruvuButton
        size="small"
        variant="secondary"
        startIcon={<Phone />}
        onClick={onOpenWhatsapp}
        disabled={
          agentInfo.contactNumber == null || agentInfo.contactNumber === ''
        }
      >
        Whats Chat
      </TruvuButton>
    </Stack>
  );
}
